'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentError = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var attachmentError = exports.attachmentError = (0, _reduxActions.createAction)(_fileUploadsActionTypes.ATTACHMENT_ERROR, function (error, threadId) {
  return { error: error, threadId: threadId };
});


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/attachmentError.js
// module id = 239
// module chunks = 2 3